class FeaturedImageGallery {
  constructor() {
    this.modal = document.getElementById('galleryModal');
    this.modalImage = this.modal?.querySelector('.gallery-modal__image');
    this.galleryImages = document.querySelectorAll('[data-gallery-image]');
    
    if (!this.modal || !this.modalImage) return;
    
    this.init();
  }

  init() {
    // Add click listeners to all gallery images
    this.galleryImages.forEach((img) => {
      img.addEventListener('click', (e) => this.openModal(e));
    });

    // Close modal on overlay or close button click
    const closeButtons = this.modal.querySelectorAll('[data-modal-close]');
    closeButtons.forEach((btn) => {
      btn.addEventListener('click', () => this.closeModal());
    });

    // Close modal on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.closeModal();
      }
    });

    // Close modal on swipe down (mobile)
    this.setupSwipeToClose();
  }

  openModal(event) {
    const img = event.currentTarget;
    
    // Get the full resolution image URL from data attribute
    const fullSizeUrl = img.dataset.galleryFullsize || img.src.split('?')[0];
    
    this.modalImage.src = fullSizeUrl;
    this.modalImage.alt = img.alt;
    
    // Add active class to show modal
    this.modal.classList.add('active');
    
    // Prevent body scroll
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.classList.remove('active');
    
    // Restore body scroll
    document.body.style.overflow = '';
  }

  setupSwipeToClose() {
    let touchStartY = 0;
    let touchEndY = 0;

    const handleTouchStart = (e) => {
      touchStartY = e.changedTouches[0].screenY;
    };

    const handleTouchEnd = (e) => {
      touchEndY = e.changedTouches[0].screenY;
      
      // If swiped down by at least 50px, close modal
      if (touchEndY - touchStartY > 50) {
        this.closeModal();
      }
    };

    this.modal.addEventListener('touchstart', handleTouchStart, false);
    this.modal.addEventListener('touchend', handleTouchEnd, false);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new FeaturedImageGallery();
  });
} else {
  new FeaturedImageGallery();
}
